import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebaseConfig';
import Blog from './pages/Blog';
import PrivacyPolicy from './pages/PrivacyPolicy';

// --- GÜVENLİK BEKÇİLERİ ---
import ProtectedRoute from './components/ProtectedRoute';
import SubscriptionGuard from './components/SubscriptionGuard';

// --- SAYFALAR ---
import LandingPage from './pages/LandingPage'; // 🚀 1. VİTRİN SAYFASI EKLENDİ
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import ChangeName from './pages/ChangeName';
import AboutContact from './pages/AboutContact'; 
import VetHelperAiEmbed from './pages/VetHelperAi';

// --- KLİNİK ARAÇLAR ---
import DoseHelper from './pages/DoseHelper';
import Hemogram from './pages/Hemogram';
import Biochemistry from './pages/Biochemistry';
import ShockHelper from './pages/ShockHelper';
import LiquidHelper from './pages/LiquidHelper';
import DrugDetail from './pages/DrugDetail';
import DrugGuide from './pages/DrugGuide';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && user.emailVerified) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    signOut(auth).then(() => {
      window.location.href = '/login';
    });
  };

  if (loading) return <div style={loaderStyle}>Sistem Yükleniyor...</div>;

  return (
    <Router>
      {/* ÜST MENÜ - SADECE GİRİŞ YAPMIŞ KULLANICILAR GÖRÜR */}
      {isLoggedIn && (
        <nav style={navStyle}>
          <div style={navContainer}>
            <Link to="/" style={linkStyle}>🏠 Ana Sayfa</Link>
            <Link to="/vethelper-ai" style={linkStyle}>🤖 VetHelper AI</Link>
            <Link to="/drug-guide" style={linkStyle}>💊 İlaç Rehberi</Link>
            <Link to="/dose-helper" style={linkStyle}>⚖️ Doz Rehberi</Link>
            <Link to="/hemogram" style={linkStyle}>🩸 Hemogram Yorumu</Link>
            <Link to="/biochemistry" style={linkStyle}>🧪 Biyokimya Yorumu</Link>
            <Link to="/liquid-helper" style={linkStyle}>💧 Sıvı Sağaltımı</Link>
            <Link to="/shock-helper" style={linkStyle}>⚡ Şok Sağaltımı</Link>
            <Link to="/profile" style={linkStyle}>👤 Profil</Link>
            <Link to="/about" style={linkStyle}>ℹ️ Hakkımızda</Link>
            <button onClick={handleLogout} style={logoutBtn}>ÇIKIŞ</button>
          </div>
        </nav>
      )}

      {/* İÇERİK ALANI */}
      <div style={isLoggedIn ? loggedInContentStyle : publicContentStyle}>
        <Routes>
          {/* HERKESE AÇIK ROTALAR */}
          <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/about" element={<AboutContact />} />

          {/* 🔥 2. AKILLI ANA SAYFA YÖNLENDİRMESİ 🔥 */}
          <Route
            path="/"
            element={
              isLoggedIn ? (
                <SubscriptionGuard>
                  <Home />
                </SubscriptionGuard>
              ) : (
                <LandingPage />
              )
            }
          />

          {/* KORUMALI ROTALAR (SADECE GİRİŞ YAPMIŞ KULLANICILAR) */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-name"
            element={
              <ProtectedRoute>
                <ChangeName />
              </ProtectedRoute>
            }
          />

          {/* ABONELİK GEREKTİREN DİĞER ROTALAR (GİRİŞ + AKTİF ABONELİK) */}
          <Route
            path="/vethelper-ai"
            element={
              <SubscriptionGuard>
                <VetHelperAiEmbed />
              </SubscriptionGuard>
            }
          />
          <Route
            path="/drug-guide"
            element={
              <SubscriptionGuard>
                <DrugGuide />
              </SubscriptionGuard>
            }
          />
          <Route
            path="/drug/:id"
            element={
              <SubscriptionGuard>
                <DrugDetail />
              </SubscriptionGuard>
            }
          />
          <Route
            path="/dose-helper"
            element={
              <SubscriptionGuard>
                <DoseHelper />
              </SubscriptionGuard>
            }
          />
          <Route
            path="/hemogram"
            element={
              <SubscriptionGuard>
                <Hemogram />
              </SubscriptionGuard>
            }
          />
          <Route
            path="/biochemistry"
            element={
              <SubscriptionGuard>
                <Biochemistry />
              </SubscriptionGuard>
            }
          />
          <Route
            path="/shock-helper"
            element={
              <SubscriptionGuard>
                <ShockHelper />
              </SubscriptionGuard>
            }
          />
          <Route
            path="/liquid-helper"
            element={
              <SubscriptionGuard>
                <LiquidHelper />
              </SubscriptionGuard>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

// --- CSS STİLLERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const navStyle = {
  background: '#2c3e50',
  paddingTop: 'max(12px, env(safe-area-inset-top))', // iOS Çentik Koruması
  paddingBottom: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  zIndex: 9999,
  boxSizing: 'border-box'
};

const navContainer = {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px', 
  flexWrap: 'wrap', 
  padding: '0 10px',
  boxSizing: 'border-box'
};

const linkStyle = {
  color: '#ecf0f1',
  textDecoration: 'none',
  fontWeight: '600',
  fontSize: '11px',
  padding: '8px 10px',
  borderRadius: '6px',
  backgroundColor: 'rgba(255,255,255,0.1)',
  marginBottom: '2px',
  display: 'inline-block',
  WebkitTapHighlightColor: 'transparent'
};

const logoutBtn = {
  background: '#e74c3c',
  color: '#fff',
  border: 'none',
  padding: '8px 12px',
  borderRadius: '6px',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '11px',
  marginLeft: '5px',
  WebkitTapHighlightColor: 'transparent'
};

const loggedInContentStyle = {
  paddingTop: 'calc(max(50px, env(safe-area-inset-top)) + 82px)',
  minHeight: '100vh',
  background: '#f8f9fa',
  paddingBottom: '20px',
  boxSizing: 'border-box'
};

const publicContentStyle = {
  minHeight: '100vh',
  background: '#ecf0f1',
  boxSizing: 'border-box'
};

const loaderStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  color: '#2c3e50',
  fontSize: '18px',
  fontWeight: 'bold'
};

export default App;